import ErrorFallback from 'Components/ErrorFallback'
import {
  SalesRuleCreatePage,
  SalesRuleEditPage,
  SalesRuleListPage
} from 'Services/ProductManagement/Features/SalesRule/Pages'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'

function SalesRuleRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route index element={<SalesRuleListPage />} />
        <Route path="create" element={<SalesRuleCreatePage />} />
        <Route path=":id/edit" element={<SalesRuleEditPage />} />
      </Routes>
    </ErrorBoundary>
  )
}

export default SalesRuleRoot
